import { render } from "./EmployeeBalance.vue?vue&type=template&id=5cf4974a&scoped=true"
import script from "./EmployeeBalance.vue?vue&type=script&lang=js"
export * from "./EmployeeBalance.vue?vue&type=script&lang=js"

import "./EmployeeBalance.vue?vue&type=style&index=0&id=5cf4974a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf4974a"]])

export default __exports__